import './styles.scss';
import { registerFragment } from '@neptune/cx/registry';
import { DisposalSet } from '@neptune/cx/utils';

const gc = new DisposalSet();

registerFragment('chroa-members-network', (fragmentElement, config, meta) => {
    var bgAdj;

    bgAdj = function() {
        var elements, ref, setB, setB2, setH, tempHead, tempStyle;
        elements = document.getElementsByClassName('chroa-site-header--slide-under');
        setB = elements[0].getAttribute('style');
        setB2 = setB.replace('--lfr-background-image-7eac6938-4836-54a0-6832-db36009579bd', 'background-image');
        setH = elements[0].offsetHeight + 377 + 97;
        tempHead = document.head || document.getElementsByTagName('head')[0];
        tempStyle = document.createElement('style');
        tempStyle.type = 'text/css';
        tempStyle.id = 'memBackBanner';
        tempStyle.innerHTML = '.chroa-site-header--slide-under:after {' + 'height: ' + setH + 'px;' + setB2 + '}';
        ref = document.querySelector('script');
        ref.parentNode.insertBefore(tempStyle, ref);
    };

    window.addEventListener('load', function() {
        bgAdj();
    });

    window.addEventListener('resize', function() {
        bgAdj();
    });
});

if (import.meta.hot) {
    import.meta.hot.accept();
    import.meta.hot.dispose(() => gc.disposeAll());
}

